import { pushStorefrontDataToDatalayer } from '../../analytics/storefront'
import { StorefrontData, StorefrontFile } from '../models/StorefrontData'
import { StoreFrontState } from '../models/StoreFrontState'
import {
  FETCH_STOREFRONT_DONE,
  FETCH_STOREFRONT_FILES,
  FETCH_STOREFRONT_STORE_ID,
  FETCH_STOREFRONT_TOKEN,
  StoreFrontActionTypes
} from './actions/storefront.actions'

export function done(data: StorefrontData): StoreFrontActionTypes {
  return {
    type: FETCH_STOREFRONT_DONE,
    payload: {
      data
    }
  }
}

export function initial(data: StorefrontData): StoreFrontActionTypes {
  pushStorefrontDataToDatalayer(data)
  return done(data)
}

export function storeFiles(files: StorefrontFile[]): StoreFrontActionTypes {
  return {
    type: FETCH_STOREFRONT_FILES,
    payload: {
      files
    }
  }
}

export function storeToken(token: string): StoreFrontActionTypes {
  return {
    type: FETCH_STOREFRONT_TOKEN,
    payload: {
      token
    }
  }
}

export function storeId(id: string): StoreFrontActionTypes {
  return {
    type: FETCH_STOREFRONT_STORE_ID,
    payload: {
      id
    }
  }
}

export function setStorefrontFiles(files: StorefrontFile[]): StoreFrontActionTypes {
  return {
    type: FETCH_STOREFRONT_FILES,
    payload: {
      files
    }
  }
}

export function getStorefrontData(store: { storefront: StoreFrontState }): StorefrontData {
  return store.storefront.data
}

export function getStorefrontFiles(store: { storefront: StoreFrontState }): StorefrontFile[] {
  return store.storefront.files
}

export function getStorefrontToken(store: { storefront: StoreFrontState }): string {
  return store.storefront.token
}

export function getStoreFrontId(store: { storefront: StoreFrontState }): string {
  return store.storefront.id
}

export function getStorefrontStatus(store: { storefront: StoreFrontState }): unknown {
  return store.storefront.data.transaction?.status
}

const initialState: StoreFrontState = {
  id: '',
  data: {},
  files: [],
  token: ''
}

export default function storefrontReducer(
  state = initialState,
  action: StoreFrontActionTypes
): StoreFrontState {
  switch (action.type) {
    case FETCH_STOREFRONT_DONE:
      return {
        ...state,
        data: action.payload.data
      }
    case FETCH_STOREFRONT_STORE_ID:
      return {
        ...state,
        id: action.payload.id
      }
    case FETCH_STOREFRONT_FILES:
      return {
        ...state,
        files: action.payload.files
      }
    case FETCH_STOREFRONT_TOKEN:
      return {
        ...state,
        token: action.payload.token
      }

    default:
      return state
  }
}
